import { Box, Rating, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Product } from '../../interfaces/Product/Product';
import { ProductReview } from '../../interfaces/Product/ProductReview';
import { sharedColors } from '../../utils/Style';

type ProductReviewSummaryProps = {
  product: Product;
  reviews?: ProductReview;
};

export const ProductReviewSummary = ({
  product,
  reviews,
}: ProductReviewSummaryProps) => {
  const labelStyle = {
    fontSize: '12px',
    color: sharedColors.gray6,
  };

  const highlightStyle = {
    fontSize: '12px',
    fontWeight: 600,
    color: sharedColors.gray7,
  };

  const content: ReactNode[] = [
    <Typography sx={labelStyle}>
      <Typography component='span' sx={highlightStyle}>
        {product.viewed}
      </Typography>{' '}
      Görüntülenme
    </Typography>,
  ];
  if (reviews?.totalCount) {
    content.push(
      <Typography sx={labelStyle}>
        <Typography component='span' sx={highlightStyle}>
          {reviews.totalCount}
        </Typography>{' '}
        Değerlendirme
      </Typography>,
    );
  }
  if (reviews?.avgRating) {
    content.push(
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.5,
          alignItems: 'center',
        }}
      >
        <Typography sx={{ ...highlightStyle, fontSize: '16px' }}>
          {reviews.avgRating.toFixed(1)}
        </Typography>

        <Rating size='small' readOnly value={reviews.avgRating} />
      </Box>,
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {content.map((item, i) => (
        <>
          {item}
          {i < content.length - 1 && (
            <Typography sx={{ mt: 0.25 }}> • </Typography>
          )}
        </>
      ))}
    </Box>
  );
};
